import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDSpForceStandDetails implements ICommand
{

	public GameID : number = 0;
	public Reason : number = 0;
	public PlayerID : number = 0;
	public MoreInfo : string = "";

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.GameID = ba.readInt53();
		this.Reason = ba.readUint32();
		this.PlayerID = ba.readUint53();
		this.MoreInfo = ba.readString();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint53(this.GameID);
		ba.writeUint32(this.Reason);
		ba.writeUint53(this.PlayerID);
		ba.writeString(this.MoreInfo);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDSpForceStandDetails();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'GameID(Q)='+this.GameID+' ';
		str += 'Reason(D)='+this.Reason+' ';
		str += 'PlayerID(Q)='+this.PlayerID+' ';
		str += 'MoreInfo(S)='+this.MoreInfo+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 50148;
	}

	public getCmdName() : string
	{
		return 'SpForceStandDetails';
	}

}
